import React from 'react'

export const LinkedInIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.45005 4.19998C8.85397 4.19793 8.26334 4.31345 7.71194 4.53992C7.16055 4.7664 6.65922 5.09938 6.23665 5.51982C5.81407 5.94026 5.47854 6.43991 5.24925 6.99017C5.01996 7.54042 4.90141 8.1305 4.90039 8.72662V13.2999C4.90039 13.4856 4.97414 13.6636 5.1054 13.7949C5.23667 13.9262 5.4147 13.9999 5.60034 13.9999H7.23355C7.41919 13.9999 7.59722 13.9262 7.72849 13.7949C7.85975 13.6636 7.9335 13.4856 7.9335 13.2999V8.72662C7.93335 8.5146 7.97787 8.30493 8.06418 8.11127C8.15049 7.91762 8.27663 7.74433 8.4344 7.60269C8.59216 7.46106 8.778 7.35427 8.97981 7.28928C9.18161 7.2243 9.39484 7.20257 9.6056 7.22552C9.98357 7.27313 10.3309 7.45781 10.5818 7.74454C10.8327 8.03126 10.9696 8.40009 10.9666 8.78107V13.2999C10.9666 13.4856 11.0404 13.6636 11.1716 13.7949C11.3029 13.9262 11.4809 13.9999 11.6666 13.9999H13.2998C13.4854 13.9999 13.6634 13.9262 13.7947 13.7949C13.926 13.6636 13.9997 13.4856 13.9997 13.2999V8.72662C13.9987 8.1305 13.8801 7.54042 13.6509 6.99017C13.4216 6.43991 13.086 5.94026 12.6635 5.51982C12.2409 5.09938 11.7396 4.7664 11.1882 4.53992C10.6368 4.31345 10.0461 4.19793 9.45005 4.19998Z"
      fill="currentColor"
    />
    <path
      d="M2.79979 4.90015H0.699948C0.313377 4.90015 0 5.21355 0 5.60014V13.3001C0 13.6867 0.313377 14.0001 0.699948 14.0001H2.79979C3.18636 14.0001 3.49974 13.6867 3.49974 13.3001V5.60014C3.49974 5.21355 3.18636 4.90015 2.79979 4.90015Z"
      fill="currentColor"
    />
    <path
      d="M1.74987 3.49998C2.7163 3.49998 3.49974 2.71649 3.49974 1.74999C3.49974 0.783498 2.7163 0 1.74987 0C0.783443 0 0 0.783498 0 1.74999C0 2.71649 0.783443 3.49998 1.74987 3.49998Z"
      fill="currentColor"
    />
  </svg>
)
